<template>
  <li
    :class="[
      '-frame-io-dropdown',
      {
        '-disabled': frameIoToken === null || (frameIoToken && !teams.length),
        '-active': showTeams,
      },
    ]"
  >
    <div class="-link -brand">
      <wt-button
        type="transparent"
        class="-custom"
        :text="'frameIo.share' | culture"
        @click="frameIoToken === false ? connectFrameIo() : toggleFrameIoMenu()"
      >
      </wt-button>
      <i
        class="-menu-chevron wticon wticon-chevron-right"
        v-if="frameIoToken"
      />
      <img
        class="-logo-hashtag"
        src="/resources/img/social/frameio.svg"
        alt=""
        width="16"
      />
    </div>
    <div class="-inner-menu" v-if="teamsMenuVisible" ref="teams">
      <li
        v-for="team in teams"
        :key="team.id"
        :class="{
          '-disabled': !projects[team.id],
          '-active': selectedTeam === team.id,
        }"
        :ref="'team' + team.id"
      >
        <div class="-link">
          <wt-button
            type="transparent"
            class="-custom"
            @click="onClickTeam(team)"
            :text="team.name"
          >
          </wt-button>
          <i
            v-if="projects[team.id]"
            class="-menu-chevron wticon wticon-chevron-right"
          />
        </div>
      </li>
    </div>
    <div class="-inner-menu" v-if="projectMenuVisible" ref="projects">
      <li
        v-for="project in projects[selectedTeam]"
        :key="project.id"
        :class="{
          '-disabled': project.uploading,
          '-active': project.uploading,
        }"
      >
        <div class="-link">
          <wt-button
            type="transparent"
            class="-custom"
            :text="project.name"
            @click="onClickProject(project)"
          >
          </wt-button>
          <i
            class="-menu-chevron wticon wticon-chevron-right"
            v-if="doesProjectHaveFolders(project)"
          />
          <wt-google-like-loader
            v-if="project.uploading"
            class="-default -uploading"
          />
        </div>
      </li>
    </div>
    <!--
      folders menu currently not supported
    -->
    <!-- <div class="-inner-menu" v-if="selectedProject === project.id">
      <li
      v-for="folder in folders[selectedProject]"
      :key="folder.id">
        <div class="-link">
          <wt-button
            type="transparent"
            class="-custom"
            :text="folder.name"
            @click="upload(folder.id)">
          </wt-button>
        </div>
      </li>
    </div> -->
  </li>
</template>

<script>
export default {
  data() {
    return {
      frameIoToken: null,
      teams: [],
      accounts: [],
      showTeams: false,
      selectedTeam: null,
      projects: {},
      selectedProject: null,
      folders: {},
      selectedFolder: null,
    };
  },
  props: {
    story: { type: Object, required: true },
    previewVideoUrl: { type: String, default: '' },
  },
  mounted() {
    this.checkFrameIoAccount()
      .then(() => {
        this.getFrameIOProjects();
      })
      .catch(_.noop);
  },

  methods: {
    resetMenu() {
      this.showTeams = false;
      this.selectedTeam = null;
      this.selectedProject = null;
      this.selectedFolder = null;
    },
    /**
     * Call frame.io API
     * param {String} url endpoint
     */
    callFrameIo(url, method = 'GET', body) {
      return new Promise((resolve, reject) => {
        fetch(`https://api.frame.io/v2/${url}`, {
          method,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.frameIoToken}`,
          },
          body,
        })
          .then((resp) => {
            resolve(resp.json());
          })
          .catch((e) => {
            app.doctorController.report(
              `FrameIO API Integration Error -> ${e.message?.toString()}, ${url}`
            );
            reject(e);
          });
      });
    },
    /**
     * Check if user has a frame.io account
     */
    checkFrameIoAccount() {
      return new Promise((resolve, reject) => {
        app.api.socialProvider
          .getUserAccounts()
          .then((accounts) => {
            if (!_.isEmpty(accounts.frameio)) {
              this.frameIoToken = accounts.frameio.accessToken;
              resolve();
            } else {
              this.frameIoToken = false;
              reject();
            }
          })
          .fail((e) => {
            this.frameIoToken = false;
            reject();
          });
      });
    },
    /**
     * Get all frame.io projects
     */
    async getFrameIOProjects() {
      this.teams = [];
      this.accounts = [];
      const onFail = () => {
        app.doctorController.report(
          "FrameIO API Integration Error -> Couldn't retrieve Frame.io project details."
        );
        this.frameIoToken = false;
      };
      this.callFrameIo('accounts')
        .then((accounts) => {
          this.accounts = accounts;
          accounts.forEach((account) => {
            if (account.team_count === 0) {
              return;
            }
            this.accounts.push(account);
            const accountId = account.id;
            this.callFrameIo(`accounts/${accountId}/teams`)
              .then((teams) => {
                teams.forEach(async (team) => {
                  this.teams.push(team);
                  this.callFrameIo(`teams/${team.id}/projects`)
                    .then((teamProjects) => {
                      if (teamProjects.length) {
                        app.Vue.set(this.projects, team.id, teamProjects);
                      }
                    })
                    .catch(onFail);
                });
              })
              .catch(onFail);
          });
        })
        .catch(onFail);
    },
    /**
     * upload url to frame.io
     * param {project} target project
     */
    async upload(project) {
      const folderId = project.root_asset_id;
      app.Vue.set(project, 'uploading', true);
      const onFail = (e) => {
        app.Vue.set(project, 'uploading', false);
        app.notificationController.push({
          type: 'ERROR',
          text: `Failed to send video to '${project.name}'`,
          timeout: app.TIME.second(2),
        });
      };
      // token may be expired, refresh it first.
      this.checkFrameIoAccount()
        .then(() => {
          this.callFrameIo(
            `assets/${folderId}/children`,
            'POST',
            JSON.stringify({
              name: this.story.get('title'),
              properties: {},
              source: { url: this.previewVideoUrl },
              type: 'file',
            })
          )
            .then((res) => {
              if (res.status != 'created') {
                return onFail();
              }
              this.$emit('close');
              app.Vue.set(project, 'uploading', false);
              app.notificationController.push({
                type: 'SUCCESS',
                text: `Your video was sent to '${project.name}'`,
                timeout: app.TIME.second(2),
              });
            })
            .catch(onFail);
        })
        .catch(onFail);
    },
    /**
     * Toggle frame.io menu
     */
    toggleFrameIoMenu() {
      if (this.showTeams) {
        this.resetMenu();
      } else {
        this.showTeams = true;
      }
    },
    /**
     * Trigger Frame.io oauth popup
     */
    connectFrameIo() {
      // alert('login');
      // this.$triggerAnalytics('frameio:connected');
      app.api.socialProvider
        .connect(this.story, app.api.socialProvider.providers.FRAMEIO)
        .done((data) => {
          // eslint-disable-next-line prefer-rest-params
          console.log('frameio: connect success!', arguments);
          this.checkFrameIoAccount()
            .then(() => {
              this.getFrameIOProjects();
            })
            .catch(_.noop);
          this.showTeams = true;
        })
        .fail((err) => {
          if (err && err.isCanceled) {
            // eslint-disable-next-line prefer-rest-params
            console.log('frame: connect canceled!', arguments);
          } else {
            // eslint-disable-next-line prefer-rest-params
            console.log('frame: connect error!', arguments);
            app.dialog.error({
              type: app.dialog.types.ERROR_1,
              title: 'Action Failed',
              description: 'Unexpected error occurred. </br>',
              showContactCsm: true,
            });
          }
        });
    },
    /**
     * Select team
     * param {Object} team
     */
    onClickTeam(team) {
      this.selectedProject = null;
      if (this.selectedTeam === team.id) {
        this.selectedTeam = null;
      } else {
        this.selectedTeam = team.id;
      }
    },
    /**
     * Select a project
     * param {Object} project
     * If a project doesnt have any inner folders, upload to project root folder
     */
    onClickProject(project) {
      if (
        this.selectedProject == project.id &&
        this.doesProjectHaveFolders(project)
      ) {
        this.selectedProject = null;
      } else {
        this.selectedProject = project.id;
        if (!this.doesProjectHaveFolders(project)) {
          this.upload(project);
        }
      }
    },
    doesProjectHaveFolders(project) {
      return this.folders[project.id]?.length;
    },
    fixMenuPosition($menuEl) {
      const $previewFooter = document.querySelector('.-full-preview-footer');
      if (!$previewFooter) {
        return;
      }
      const menuRects = $menuEl.getClientRects()[0];
      const footerRects = $previewFooter.getClientRects()[0];

      if (menuRects.bottom > footerRects.top) {
        const diff = menuRects.bottom - footerRects.top;
        const currentTop = parseInt($menuEl.style.top) || 0;
        $menuEl.style.top = `${currentTop - diff}px`;
      }
    },
  },

  computed: {
    teamsMenuVisible() {
      return this.showTeams && this.teams.length;
    },
    projectMenuVisible() {
      return this.selectedTeam && this.projects[this.selectedTeam].length;
    },
    currentTeam() {
      if (this.selectedTeam) {
        return this.teams.find((team) => team.id === this.selectedTeam);
      } else {
        return false;
      }
    },
  },

  watch: {
    async teamsMenuVisible() {
      if (this.teamsMenuVisible) {
        await this.$nextTick();
        this.fixMenuPosition(this.$refs.teams);
      }
    },
    async projectMenuVisible() {
      if (this.projectMenuVisible) {
        await this.$nextTick();
        const $teamsMenu = this.$refs.teams;
        const $projectMenu = this.$refs.projects;
        const teamsMenuRect = $teamsMenu.getClientRects()[0];
        const $projectMenuRect = $projectMenu.getBoundingClientRect();
        const $teamLi = this.$refs['team' + this.selectedTeam];

        this.$refs.projects.style.right = `-${teamsMenuRect.width}px`;

        if ($teamLi.length) {
          const teamLiRects = $teamLi[0].getClientRects()[0];
          $projectMenu.style.top = `${
            teamLiRects.top - $projectMenuRect.top - 1
          }px`;
        }
        this.fixMenuPosition(this.$refs.projects);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.-frame-io-dropdown {
  position: relative;
}
.-menu-chevron {
  font-size: 14px;
  position: absolute;
  right: 10px;
  pointer-events: none;
}
.-uploading {
  position: absolute !important;
  right: 10px;
}
.-disabled {
  pointer-events: none;
}
.-inner-menu {
  position: absolute;
  right: 0;
  top: -1px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  transform: translateX(calc(100% + 1px));
  background: white;
  border: solid 1px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  max-height: 400px;
  li {
    position: relative;
  }
  .-link {
    max-width: 300px;

    > button {
      min-width: 0;
      padding-right: 45px;
      &/deep/ span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
